import { useEffect } from 'react'
import { Routes, Route } from 'react-router-dom'
import { useAuthStore } from './context/store'
import Layout from './components/layout/Layout'
import HomePage from './pages/HomePage'
import CataloguePage from './pages/CataloguePage'
import CollectionPage from './pages/CollectionPage'
import ProductPage from './pages/ProductPage'
import CustomizerPage from './pages/CustomizerPage'
import CartPage from './pages/CartPage'
import AccountPage from './pages/AccountPage'
import SavedDesignsPage from './pages/SavedDesignsPage'
import NotFoundPage from './pages/NotFoundPage'
import CartDrawer from './components/cart/CartDrawer'

export default function App() {
  const initAuth = useAuthStore((s) => s.init)
  useEffect(() => { initAuth() }, [initAuth])

  return (
    <>
      <Layout>
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/catalogue" element={<CataloguePage />} />
          <Route path="/collections/:handle" element={<CollectionPage />} />
          <Route path="/products/:handle" element={<ProductPage />} />
          <Route path="/customize" element={<CustomizerPage />} />
          <Route path="/cart" element={<CartPage />} />
          <Route path="/account" element={<AccountPage />} />
          <Route path="/account/saved-designs" element={<SavedDesignsPage />} />
          <Route path="*" element={<NotFoundPage />} />
        </Routes>
      </Layout>
      <CartDrawer />
    </>
  )
}
